/** Interfaces */
import { BydRefreshLoginInterface } from '../interfaces/byd-refresh-login.interface';

export class BydRefreshLogin implements BydRefreshLoginInterface {
  /**
   * The refresh token is used to obtain new access/refresh
   * token pairs when the current access token expires
   */
  readonly refreshToken: string;

  /**
   * Creates an instance of BydRefreshLogin.
   *
   * @param refreshLogin the user refresh login data
   */
  constructor(refreshLogin: BydRefreshLoginInterface) {
    this.refreshToken = refreshLogin.refreshToken;
  }
}
